<template>
    <div
        v-if="contentTypesWithPermissions?.length > 1"
        class="inline-flex rounded bg-slate-200 p-1 shadow-sm hover:shadow-sm focus:shadow-sm"
        :class="containerClass"
        role="group"
    >
        <Tooltip
            v-for="contentType in contentTypesWithPermissions"
            :key="contentType.key"
            :show-tooltip="contentType.key === 'story' && !contentType.hasPermission"
        >
            <template #trigger>
                <button
                    class="flex rounded transition duration-150 ease-in-out focus:outline-none focus:ring-0"
                    :class="[
                        buttonClass,
                        {
                            'bg-white text-slate-900': modelValue === contentType.key,
                            'text-slate-500 hover:text-slate-700': modelValue !== contentType.key && contentType.hasPermission,
                            'text-slate-400 cursor-not-allowed opacity-50': !contentType.hasPermission,
                        }
                    ]"
                    :disabled="!contentType.hasPermission"
                    @click.prevent="contentType.hasPermission ? $emit('update:modelValue', contentType.key) : null"
                >
                    <AppIcon
                        v-if="contentType.key === 'story' && !contentType.hasPermission"
                        name="lock"
                        class="mr-1 h-3 w-3 my-auto"
                    />
                    <span class="capitalize">
                        {{ useDictionary ? getFromDictionary(`superview.contentType.switcher.${platformId}.${contentType.key}`) : contentType.key }}
                    </span>
                </button>
            </template>
            <template #default>
                <div class="whitespace-nowrap text-xs">
                    Upgrade required for <span class="font-semibold text-white">Instagram Stories</span>, <br />talk to our team for access.
                </div>
            </template>
        </Tooltip>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import _ from 'lodash'
import Tooltip from '@/components/Tooltip.vue'

const store = useStore()
const { checkPermission, getFromDictionary } = store.getters

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    validContentTypes: {
        type: Array,
        required: true,
    },
    platformId: {
        type: String,
        required: true,
    },
    containerClass: {
        type: String,
        default: '',
    },
    buttonClass: {
        type: String,
        default: 'px-3 py-0.5 text-xs font-semibold leading-tight text-slate-900',
    },
    useDictionary: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['update:modelValue'])

const contentTypesWithPermissions = computed(() => {
    if (!props.validContentTypes?.length) return []

    // Map over validContentTypes (which already filters for data availability)
    return _.map(props.validContentTypes, (contentTypeKey) => {
        const hasPermission = contentTypeKey === 'story' ? checkPermission('feature.instagram.stories') : true

        return {
            key: contentTypeKey,
            hasData: true,
            hasPermission,
            isDisabled: !hasPermission
        }
    })
})
</script>